import * as React from "react";
import ViewsHighlightingRules from "views/components/sidebar/highlighting/ViewsHighlightingRules";
import ViewDescription from "./description/ViewDescription";
import AddWidgetButton from "./create/AddWidgetButton";
const sidebarSections = [
  {
    key: "viewDescription",
    title: "Description",
    icon: "info",
    content: ({ results }) => /* @__PURE__ */ React.createElement(ViewDescription, { results })
  },
  {
    key: "create",
    icon: "add",
    title: "Create",
    content: ({ toggleSidebar, sidebarIsPinned }) => /* @__PURE__ */ React.createElement(AddWidgetButton, { onClick: !sidebarIsPinned ? toggleSidebar : () => {
    } })
  },
  {
    key: "highlighting",
    icon: "format_paragraph",
    title: "Highlighting",
    content: () => /* @__PURE__ */ React.createElement(ViewsHighlightingRules, null)
  },
  {
    key: "fieldList",
    icon: "subscript",
    title: "Fields",
    content: ({ sidebarChildren }) => sidebarChildren
  }
];
export default sidebarSections;
